module.exports = __webpack_public_path__ + "static/img/hb_4-min.90af106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_4-min.png
// module id = BjNn
// module chunks = 1